var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "instance",
      class: {
        inactive: _vm.instance.inactive && !_vm.instance.parent.inactive,
        selected: _vm.selected
      }
    },
    [
      _c(
        "div",
        {
          ref: "self",
          staticClass: "self selectable-item",
          class: {
            selected: _vm.selected
          },
          style: {
            paddingLeft: _vm.depth * 15 + "px"
          },
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.select($event)
            },
            dblclick: function($event) {
              $event.stopPropagation()
              return _vm.toggle($event)
            },
            mouseenter: _vm.enter,
            mouseleave: _vm.leave
          }
        },
        [
          _c("span", { staticClass: "content" }, [
            _vm.instance.children.length
              ? _c(
                  "span",
                  {
                    staticClass: "arrow-wrapper",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.toggle($event)
                      }
                    }
                  },
                  [
                    _c("span", {
                      staticClass: "arrow right",
                      class: { rotated: _vm.expanded }
                    })
                  ]
                )
              : _vm._e(),
            _c("span", { staticClass: "angle-bracket" }, [_vm._v("<")]),
            _c("span", { staticClass: "item-name" }, [
              _vm._v(_vm._s(_vm.displayName))
            ]),
            _vm.componentHasKey
              ? _c("span", { staticClass: "attr" }, [
                  _c("span", { staticClass: "attr-title" }, [_vm._v(" key")]),
                  _vm._v("="),
                  _c("span", { staticClass: "attr-value" }, [
                    _vm._v(_vm._s(_vm.instance.renderKey))
                  ])
                ])
              : _vm._e(),
            _c("span", { staticClass: "angle-bracket" }, [_vm._v(">")])
          ]),
          _vm.instance.consoleId
            ? _c(
                "span",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$t("ComponentInstance.consoleId.tooltip", {
                        id: _vm.instance.consoleId
                      }),
                      expression:
                        "$t('ComponentInstance.consoleId.tooltip', { id: instance.consoleId })"
                    }
                  ],
                  staticClass: "info console"
                },
                [
                  _vm._v(
                    "\n      = " + _vm._s(_vm.instance.consoleId) + "\n    "
                  )
                ]
              )
            : _vm._e(),
          _vm.instance.isRouterView
            ? _c("span", { staticClass: "info router-view" }, [
                _vm._v(
                  "\n      router-view" +
                    _vm._s(
                      _vm.instance.matchedRouteSegment
                        ? ": " + _vm.instance.matchedRouteSegment
                        : null
                    ) +
                    "\n    "
                )
              ])
            : _vm._e(),
          _vm.instance.isFragment
            ? _c("span", { staticClass: "info fragment" }, [
                _vm._v("\n      fragment\n    ")
              ])
            : _vm._e(),
          _vm.instance.functional
            ? _c("span", { staticClass: "info functional" }, [
                _vm._v("\n      functional\n    ")
              ])
            : _vm._e(),
          _vm.instance.inactive
            ? _c("span", { staticClass: "info inactive" }, [
                _vm._v("\n      inactive\n    ")
              ])
            : _vm._e(),
          _c("span", { staticClass: "spacer" }),
          _c("VueIcon", {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: "Scroll into view",
                expression: "'Scroll into view'"
              }
            ],
            staticClass: "icon-button",
            attrs: { icon: "visibility" },
            on: { click: _vm.scrollToInstance }
          })
        ],
        1
      ),
      _vm.expanded
        ? _c(
            "div",
            _vm._l(_vm.sortedChildren, function(child) {
              return _c("component-instance", {
                key: child.id,
                attrs: { instance: child, depth: _vm.depth + 1 }
              })
            }),
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }